export enum DracoLinkSizeValues {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
};
export type DracoLinkSizes = `${DracoLinkSizeValues}`;

export enum DracoLinkIconPositionValues {
  Leading = 'leading',
  Trailing = 'trailing'
};
export type DracoLinkIconPositions = `${DracoLinkIconPositionValues}`;